import axios from "axios";
async function getUser() {
    const response = await axios
        .get(`${process.env.REACT_APP_API_ENDPOINT}/home`)
    // .catch(function (error) {
    //   log(error.response);
    //   return error.response;
    // });
    const user = response;
    return user;
}
export default getUser;
